module.exports = __webpack_public_path__ + "img/img03.cd722208.jpg";